module.exports = __webpack_public_path__ + "components/snow-icon/static/icon-snowflake-1d0f34830ec9f0d4a4723cb70280aacb.svg";